import { lazy } from "react";

const Exportacao = lazy(() => import("../../views/exportacao"));

const exportacaoRoutes = [
  {
    path: "/exportacao",
    element: <Exportacao />,
    isPrivate: true,
  },
];

export default exportacaoRoutes;
